import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import {
  collection,
  onSnapshot,
  doc,
  setDoc,
  deleteDoc,
} from "firebase/firestore";
import { auth, db } from "../../firebase/firebase.js";
import FIELD_MAP from "../../constants/profileFields.js";

export default function PendingProfileUpdates() {
  const uid = auth.currentUser?.uid;
  const [updates, setUpdates] = useState([]);

  useEffect(() => {
    if (!uid) return;
    const unsub = onSnapshot(
      collection(db, "users", uid, "pendingProfileUpdates"),
      (snap) => setUpdates(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );
    return unsub;
  }, [uid]);

  const accept = async (u) => {
    await setDoc(
      doc(db, "users", uid),
      { [FIELD_MAP[u.id] || u.id]: u.proposed },
      { merge: true }
    );
    await deleteDoc(doc(db, "users", uid, "pendingProfileUpdates", u.id));
  };

  const reject = async (u) => {
    await deleteDoc(doc(db, "users", uid, "pendingProfileUpdates", u.id));
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>
        Pending Profile Updates
      </Typography>
      {updates.length === 0 ? (
        <Typography data-testid="no-pending-updates-message">
          No pending updates.
        </Typography>
      ) : (
        <Stack spacing={2} data-testid="pending-updates-list-container">
          {updates.map(
            (
              u,
              index // Added index
            ) => (
              <Box
                key={u.id}
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
                data-testid={index === 0 ? "pending-update-item-0" : undefined} // Added data-testid for first item
              >
                <Typography
                  sx={{ flexGrow: 1 }}
                  data-testid="pending-update-text"
                >
                  {u.predicate.replace(/_/g, " ")} → “{u.proposed}”
                </Typography>
                <Button
                  size="small"
                  variant="contained"
                  color="success"
                  startIcon={<CheckIcon />}
                  onClick={() => accept(u)}
                  data-testid="pending-update-accept-button" // Added data-testid
                >
                  Accept
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  color="error"
                  startIcon={<CloseIcon />}
                  onClick={() => reject(u)}
                  data-testid="pending-update-reject-button" // Added data-testid
                >
                  Reject
                </Button>
              </Box>
            )
          )}
        </Stack>
      )}
    </Box>
  );
}
